<div class="container-payments">
  <span class="title">Pagos</span>

  <span class="title">Historial de pagos</span>

  <ng-container *ngIf="!isLoading && payments.length > 0">
    <div class="table-wrapper">
      <p-table
        [value]="payments"
        [scrollable]="true"
        scrollHeight="400px"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="celda" scope="col">Fecha</th>
            <th class="celda" scope="col">Monto</th>
            <th class="celda" scope="col">Estado</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-payment>
          <tr>
            <td class="celda">{{ payment.created_at | date : 'dd/MM/yyyy' }}</td>
            <td class="celda">{{ payment.currency }} {{ payment.amount | number : '1.2-2' }}</td>
            <td class="celda">
              <span [class]="'status-badge ' + getStatusClass(payment.status)">
                {{ getStatusLabel(payment.status) }}
              </span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="no-results-cell">No hay registros</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>

  <div *ngIf="!isLoading && payments.length === 0" class="empty-state">
    <p>No hay historial de pagos disponible</p>
  </div>

  <div class="payment-method-block" *ngIf="paymentMethodDisplay">
    <span class="payment-method-label">Medio de pago registrado</span>
    <div class="payment-method-content">
      <span class="payment-method-value">
        <i class="pi pi-credit-card payment-method-icon mr-4"></i>
        {{ paymentMethodDisplay }}
      </span>
      <div class="payment-method-actions">
        <button
          pButton
          type="button"
          label="Eliminar medio de pago"
          icon="pi pi-trash"
          class="p-button-outlined p-button-danger p-button-sm"
          [loading]="isDeletingPaymentMethod"
          [disabled]="isDeletingPaymentMethod"
          (click)="confirmDeletePaymentMethod()"
        ></button>
      </div>
    </div>
  </div>
  <div class="payment-method-block empty" *ngIf="!isLoading && !paymentMethodDisplay">
    <span class="payment-method-label">No tienes un medio de pago registrado.</span>
  </div>
</div>
<p-confirmDialog key="deletePaymentMethodDialog"></p-confirmDialog>
